import * as React from 'react';
import { Collapse } from 'antd';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import TnC from './TnC';
import EFArrowRight from '@/components/UI/svg/Icons/EFArrowRight';

import useCopy from './useCopy';

export interface FaqProps {
    id?: string;
}

const { Panel } = Collapse;

function isWrappedWithHtmlTag(htmlString: string) {
    const regex = /^<([a-z][a-z0-9]*)\b[^>]*>(.*?)<\/\1>$/i;
    return regex.test(htmlString);
}

const Faq: React.FC<FaqProps> = ({ id }) => {
    const { useLang, Link, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('ecocredits');

    // const tag = React.useMemo(() => {
    //     if (locale === 'us') return 'activity';
    //     return 'default';
    // }, [locale]);
    const data = useCopy();

    return (
        <div className={css.faq} id={id}>
            <h5 className="faq_title">
                <span className="title-text">{t('faq_title')}</span>
            </h5>
            <Collapse className="faq-collapse" bordered={false} ghost expandIcon={() => <EFArrowRight />}>
                {data?.map((item) => (
                    <Panel header={item.title} key={item?.key}>
                        {item.content.map((faq, i) => (
                            <div className="faq_list" key={i}>
                                {faq.subtitle && (
                                    <h5 className="faq_q">
                                        <span className="order">{i + 1}. </span>
                                        {faq.subtitle}
                                    </h5>
                                )}
                                {isWrappedWithHtmlTag(faq.text) ? (
                                    <div dangerouslySetInnerHTML={{ __html: faq.text }}></div>
                                ) : (
                                    <div key={i} className="faq_a" dangerouslySetInnerHTML={{ __html: faq.text }}></div>
                                )}
                            </div>
                        ))}
                    </Panel>
                ))}
            </Collapse>
            <TnC />
        </div>
    );
};

export default Faq;
